//export const API_KEY = "YOUR API KEY";
export const API_KEY = "AIzaSyCckylxxtWS-5hRQ9QKFc9kB3W_Xnowcrg";

export default API_KEY;